import React, { Component } from 'react';
import styled from 'styled-components';

interface Props {
  /** CSS color to be applied to the non-gradient icon portion of the logo SVG */
  iconColor?: string;
  /** CSS color to start the gradient/shadow on the icon */
  iconGradientStart?: string;
  /** CSS color to end the gradient/shadow on the icon. Should usually match iconColor to avoid rendering issues in some browsers such as Safari. */
  iconGradientStop?: string;
  /** Accessible text to be used for screen readers (it's optional since DefaultProps contains empty string for it) */
  label?: string;
  /** The size of the icon, uses the same sizing scheme as in @atlaskit/icon */
  size?: 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge';
  /** CSS color to be applied to the wordmark portion of the logo SVG */
  textColor?: string;
}

const sizes: { [key: string]: number } = {
  large: 40,
  medium: 32,
  small: 24,
  xlarge: 48,
  xsmall: 16,
};

const Span = styled.span<Props>`
  color: ${p => p.iconColor};
  display: inline-block;
  fill: ${p => p.iconColor};
  height: ${p => p.size && sizes[p.size]}px;
  position: relative;
  user-select: none;
  width: ${p => p.size && sizes[p.size]}px;

  > svg {
    fill: inherit;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
  > canvas {
    display: block;
    height: 100%;
    visibility: hidden;
  }
`;

export default class OpsgenieIcon extends Component<Props> {
  render() {
    const { label, iconGradientStart = '#fff', iconGradientStop = '#000', ...rest } = this.props;
    return (
      <Span aria-label={label} {...rest}>
        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 60 75">
          <defs>
            <linearGradient x1="50%" y1="16.6199552%" x2="50%" y2="119.282511%" id="xflow-opsgenie-linear-gradient-1">
              <stop stopColor={iconGradientStop} offset="0%" />
              <stop stopColor={iconGradientStart} offset="82%" />
            </linearGradient>
            <linearGradient
              x1="41.179673%"
              y1="31.1603357%"
              x2="67.7136955%"
              y2="78.6783874%"
              id="xflow-opsgenie-linear-gradient-2"
            >
              <stop stopColor={iconGradientStop} offset="0%" />
              <stop stopColor={iconGradientStart} offset="62%" />
            </linearGradient>
          </defs>
          <g id="OG-neutral" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <circle
              id="Head"
              fill="url(#xflow-opsgenie-linear-gradient-1)"
              fillRule="nonzero"
              cx="30.03"
              cy="19.48"
              r="17.84"
            />
            <path
              d="M28.51,72.7 C16.8589095,65.2676874 7.16906139,55.1387948 0.26,43.17 C-0.00706762635,42.6902415 -0.0651452293,42.1217837 0.0993864182,41.59793 C0.263918066,41.0740764 0.636586216,40.6409069 1.13,40.4 L14.64,33.77 C15.5850356,33.3091685 16.7255274,33.6587445 17.25,34.57 C24.0803852,46.0180302 34.1802854,55.1601813 46.25,60.82 C41.7986409,65.3050483 36.8692225,69.2888231 31.55,72.7 C30.6198738,73.2807462 29.4401262,73.2807462 28.51,72.7 Z"
              id="Left"
              fill="url(#xflow-opsgenie-linear-gradient-2)"
              fillRule="nonzero"
            />
            <path
              d="M31.55,72.7 C43.2025971,65.2695217 52.8928378,55.1402188 59.8,43.17 C60.0677582,42.6914886 60.1273098,42.1240295 59.9647253,41.600356 C59.8021408,41.0766826 59.4316811,40.6427288 58.94,40.4 L45.42,33.77 C44.4749644,33.3091685 43.3344726,33.6587445 42.81,34.57 C35.9810497,46.0192061 25.8807421,55.1617258 13.81,60.82 C18.2586483,65.3080495 23.1884119,69.2921033 28.51,72.7 C29.4401262,73.2807462 30.6198738,73.2807462 31.55,72.7 Z"
              id="Right"
              fill={iconGradientStop}
              fillRule="nonzero"
            />
          </g>
        </svg>
      </Span>
    );
  }
}
